export default function scrollY(parent = window) {
  const supportPageOffset = window.pageXOffset !== undefined
  return supportPageOffset ? parent.pageYOffset : parent.scrollY
}
